import { Plugin } from 'grapesjs';

const DynamicTextPlugin: Plugin = (editor, opts = {}) => {
	const options = {
		blockLabel: 'Dynamic Text',
		blockCategory: 'Basic',
		blockContent: {
			type: 'dynamic-text',
			content: '{{Dynamic Text}}',
			attributes: {
				'data-gjs-type': 'dynamic-text',
				'data-dynamic-text': 'true',
			},
			classes: ['gjs-dynamic-text'],
		},
		...opts,
	};

	const bm = editor.BlockManager;
	bm.add('custom-dynamic-text', {
		label: options.blockLabel,
		category: options.blockCategory,
		media: `<svg width="75" height="30" viewBox="0 0 200 80" style="transform: scale(1); transform-origin: top left;" xmlns="http://www.w3.org/2000/svg">
			<rect x="10" y="10" width="180" height="60" rx="5" fill="#ffd700" stroke="#ffa500" stroke-width="2" opacity="0.8"/>
			<text x="50%" y="50%" font-family="Arial" font-size="14" fill="#333" text-anchor="middle" dominant-baseline="middle">Dynamic</text>
		</svg>`,
		content: options.blockContent,
	});

	editor.DomComponents.addType('dynamic-text', {
		isComponent: (el) =>
			el.tagName === 'SPAN' &&
			el.getAttribute('data-gjs-type') === 'dynamic-text'
				? { type: 'dynamic-text' }
				: undefined,
		model: {
			defaults: {
				tagName: 'span',
				components: [{ type: 'textnode', content: '{{Dynamic Text}}' }],
				attributes: {
					'data-gjs-type': 'dynamic-text',
					'data-dynamic-text': 'true',
				},
				classes: ['gjs-dynamic-text'],
				style: {
					display: 'inline',
					padding: '2px 4px',
				},
				traits: [
					{
						type: 'text',
						label: 'Placeholder Text',
						name: 'content',
						changeProp: true,
					},
				],
			},
			init() {
				this.on('change:content', () => {
					const newContent = this.get('content');
					const comps = this.components();
					if (comps.length) {
						comps.each((comp) => {
							if (comp.is('textnode'))
								comp.set('content', newContent);
						});
					} else {
						this.components().reset([
							{ type: 'textnode', content: newContent },
						]);
					}
				});
			},
		},
	});
};

export default DynamicTextPlugin;

